import { TableCell } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";

const TableHeading = () => {
  return (
    <TableHeader>
      <TableCell align="left">S.No.</TableCell>
      <TableCell align="left">Category Name</TableCell>
      <TableCell align="left">Category Index</TableCell>
      <TableCell align="left">Category Url</TableCell> 
      <TableCell align="left">Status</TableCell> 
    </TableHeader>
  );
};

export default TableHeading;
